var en = {
  translations: {
    archiveNotification: "Archive this notification",
    markAllAsRead: "Mark all as read",
    notifications: "Notifications",
    emptyFeedTitle: "No notifications yet",
    emptyFeedBody: "We'll let you know when we've got something new for you.",
    all: "All",
    unread: "Unread",
    read: "Read",
    unseen: "Unseen",
    poweredBy: "Powered by Knock"
  },
  locale: "en"
};
export default en;
//# sourceMappingURL=en.js.map